/* eslint-disable react/jsx-props-no-spreading */
import { ReactNode } from "react";
import { IconPointFilled, IconTrash } from "@tabler/icons-react";

import Link, { LinkProps, LinkType } from "../Link/Link";

export interface NotificationProps {
  title: string;
  description: string;
  date: string;
  onDelete: () => void;
  icon?: ReactNode;
  link?: Omit<LinkProps, "iconPosition" | "type">;
  read?: boolean;
}

const Notification = ({
  title, description, date, icon, link, onDelete, read = false,
}: NotificationProps) => {
  const renderDate = (className: string) => (
    <div className={`relative flex-row md:flex-col ${className} gap-4 w-full md:w-fit`}>
      <span className="text-text-subtle">{date}</span>
      <button className="text-icon-bg-subtle absolute right-0 top-0 md:top-1/3" type="button" onClick={() => onDelete()}>
        <IconTrash />
      </button>
    </div>
  );
  return (
    <div className={`flex flex-col md:flex-row w-min-[300px] md:w-min-[600px] p-4 md:p-6 gap-3 typography-medium-base
      ${read ? "bg-bg-base" : "bg-bg-interactive-light"}`}
    >
      <div className="flex gap-3">
        {!read && <IconPointFilled className="text-badge-blue-icon" />}
        {renderDate("flex md:hidden")}
      </div>
      <div className="flex flex-col w-full space-y-3">
        <div className="flex gap-3">
          {icon && <div className="text-icon-bg-base">{icon}</div>}
          <span className="text-text-base">{title}</span>
        </div>
        <span className="text-text-subtle">{description}</span>
        <Link {...link} type={LinkType.interactive} iconPosition="right" />
      </div>
      {renderDate("hidden md:flex")}
    </div>
  );
};

export default Notification;
